const toRgb = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const lerp = (a, b, t) => a + (b - a) * t;
export const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
export const rand = (a, b) => a + Math.random() * (b - a);

export function mixHex(a, b, t) {
  const A = toRgb(a);
  const B = toRgb(b);
  return `rgb(${A.map((v, i) => Math.round(lerp(v, B[i], t))).join(",")})`;
}

export function shade(hex, amt) {
  return `rgb(${toRgb(hex).map((v) => clamp(v + amt, 0, 255)).join(",")})`;
}
